module.exports = __webpack_public_path__ + "static/media/import-customers.4cde618d.svg";